// extracted by mini-css-extract-plugin
export var alertIcon = "_or-0";